<template>
  <header class="header">
    <div class="header-container">
      <a
        alt="Confira todo o conteúdo da maior casa de research do Brasil"
        class="header-logo"
        title="Confira todo o conteúdo da maior casa de research do Brasil"
        :href="empiricusURL"
        target="_blank"
      >
        <SVGLoader src="/static/svg/logo.svg" />
      </a>

      <scrollactive align-with-title active-class="active" class="my-nav header-nav" align="center">
        <a class="header-nav-item scrollactive-item" href="#inicio">Início</a>
        <a class="header-nav-item scrollactive-item" href="#empiricus-pass">Empiricus Pass Empresas</a>
        <a class="header-nav-item scrollactive-item" href="#series">Séries</a>
        <a class="header-nav-item scrollactive-item" href="#bonus">Bônus Exclusivo</a>
        <a class="header-nav-item scrollactive-item" href="#contact">Contato</a>
        <a class="header-nav-item scrollactive-item" href="#faq">FAQ</a>
      </scrollactive>

      <v-btn @click="goToForm" depressed color="var(--red)" class="header-button">
        <span style="color: var(--white)">Fale com a gente</span>
        <i style="color: var(--white)" class="mdi mdi-chevron-right"></i>
      </v-btn>

      <button class="header-button-menu" text @click="toggleClass()">
        <v-app-bar-nav-icon class="white--text" />
      </button>

    </div>

    <v-navigation-drawer
      v-model="isActive"
      absolute
      style="height: 100vh"
      class="drawer"
    >
      <ul class="drawer-menu">
        <a
          title="Confira todo o conteúdo da maior casa de research do Brasil"
          :href="empiricusURL"
          target="_blank"
        >
          <SVGLoader
            class="header-container-logo"
            src="/static/svg/logo.svg"
          />
        </a>
        <li class="header-container-nav-item-menu">
          <a href="#inicio">Início</a>
        </li>
        <li class="header-container-nav-item-menu">
          <a href="#empiricus-pass">Empiricus Pass Empresas</a>
        </li>
        <li class="header-container-nav-item-menu">
          <a href="#series">Séries</a>
        </li>
        <li class="header-container-nav-item-menu">
          <a href="#bonus">Bônus Exclusivo</a>
        </li>
        <li class="header-container-nav-item-menu">
          <a href="#contact">Contato</a>
        </li>
        <li class="header-container-nav-item-menu">
          <a href="#faq">FAQ</a>
        </li>
        <li class="header-container-nav-item-menu">
          <v-btn depressed color="var(--red)" class="cta-drawer" @click="goToForm">
            <span style="color: var(--white)">Fale com a gente</span>
            <i style="color: var(--white)" class="mdi mdi-chevron-right"></i>
          </v-btn>
        </li>
      </ul>
    </v-navigation-drawer>
  </header>
</template>

<script>
import SVGLoader from '@/components/SvgLoader'
export default {
  components: {
    SVGLoader
  },
	data() {
    return {
      isActive: false
    };
  },
  computed: {
    empiricusURL () {
      return `${process.env.APP_PUBLICACOES}`
    }
  },
  methods: {
    goToForm () {
      const form = document.getElementById('contact')
      form.scrollIntoView({ behavior: 'smooth' })
    },
    toggleClass () {
      this.isActive = !this.isActive;
    },
  },
}
</script>

<style lang="scss">
.header {
  width: 100%;
  height: 72px;
  background: var(--neutral-black-faq);
  display: flex;
  justify-content: center;
  position: fixed;
  z-index: 10;
  top: 0;

  @media only screen and (max-width: 1023px) {
    height: 60px;
  }

  &-container {
    display: flex;
    justify-content: space-between;
    align-items: center;
    max-width: 1256px;
    padding: 0 16px;
    width: 100%;

    @media only screen and (max-width: 1023px) {
      padding: 18px 24px;
    }
  }

  &-logo {
    height: 32px;

    img {
      max-width: 162px;
      width: 100%;
      cursor: pointer;
      height: auto;

      @media only screen and (max-width: 1023px) {
        max-width: 126px;
        width: 100%;
      }
    }
  }

  &-nav {
    display: flex;
    align-items: center;
    justify-content: center;

    @media only screen and (max-width: 1023px) {
      display: none;
    }

    &-item, a {
      font-family: var(--dm-sans-semibold);
      cursor: pointer;
      display: flex;
      font-size: 16x ;
      text-transform: none;
      list-style: none;
      color: var(--light-grey) !important;
      padding: 24px 20px;

      @media only screen and (max-width: 1060px) {
        padding: 24px 13px;
      }
    }

    &-item:hover {
      color: var(--dark-grey) !important;
    }

    .active {
      color: var(--white);
      border-bottom: 1px solid var(--white);
    }
  }

  &-button {
    display: block;

    @media only screen and (max-width: 1023px) {
      display: none !important;
    }
  }

  &-button-menu {
    display: none;

    @media only screen and (max-width: 1023px) {
      display: block;
    }
  }
}

.header-button {
  text-transform: none !important;
}

.header-container-nav-item-menu a {
  color: var(--dark-grey);
  margin: 4px 0;
}

.header-container-logo {
  max-width: 126px;
  width: 100%;
  height: auto;
  margin-bottom: 1rem;
}

.drawer-menu {
  align-items: flex-start;
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-top: 1rem;
  padding: 24px;

  li {
    display: flex;
    width: 100%;

    @media only screen and (max-width: 425px) {
      font-size: 12px;
    }

    a {
      color: var(--light-grey) !important;
    }
  }

  li:last-child {
    margin-top: 1rem;
  }

  .cta-drawer {
    text-transform: none !important;
    width: 100%;

    @media only screen and (max-width: 425px) {
      font-size: 12px;
      height: 30px !important;
    }
  }
}

.button-fixed {
	display: none ;
}

.drawer {
  background-color: var(--neutral-black-faq) !important;
  z-index: 6;
}
</style>



// WEBPACK FOOTER //
// src/components/Header.vue